import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';

import RenderingEnvironment from 'app/RenderingEnvironment/components/RenderingEnvironment';
import {
  RENDERING_ENVIRONMENTS_FOR_PAGE,
  PAGE_TYPES,
  RENDERING_ENVIRONMENTS_FOR_EDIT
} from 'app/RenderingEnvironment/const';
import { noop } from 'lib/noop';
import { IconButton } from 'ui/Components';
import { edit } from 'ui/Icons';

// constants
const TEMPLATE_NAME_LOCATION = 'Payload.PageTemplateName';
const PAGE_TYPE_LOCATION = 'Payload.MetadataFields.PageType';

/**
 * Returns a label showing rendering environment for
 * current page or component along with the option to
 * Edit Rendering Environment for Pages
 * @param {string} pageType - pageType
 * @param {string} pageTemplateName - pageTemplateName
 * @returns {React.Component} endering environment label
 */
class EditRenderingEnvironment extends Component {
  static propTypes = {
    className: propTypes.string,
    changePagePropertyDetail: propTypes.func,
    isNewStatus: propTypes.bool,
    isPage: propTypes.bool,
    pageTemplateName: propTypes.string,
    pageType: propTypes.string,
    renderingEnvCaption: propTypes.shape({
      pageType: propTypes.string,
      pageTemplateName: propTypes.string
    }),
    setRenderingEnv: propTypes.func
  };

  static defaultProps = {
    className: '',
    changePagePropertyDetail: noop,
    isNewStatus: true,
    isPage: false,
    pageTemplateName: null,
    pageType: null,
    renderingEnvCaption: {
      pageType: null,
      pageTemplateName: null
    },
    setRenderingEnv: noop
  };

  constructor(props) {
    super(props);
    this.state = {
      newPageModalisOpen: false,
      responsiveContentPageisOpen: false
    };
    this.newPagemodalToggle = this.newPagemodalToggle.bind(this);
    this.responsiveContentPageToggle = this.responsiveContentPageToggle.bind(this);
    this.setRenderingEnv = this.setRenderingEnv.bind(this);
  }

  /**
   * change the page template name and page type and close the modal
   * @param {object} renderingEnv - rendering environment object
   */
  setRenderingEnv(renderingEnv) {
    const { changePagePropertyDetail, setRenderingEnv } = this.props;

    setRenderingEnv(renderingEnv);
    changePagePropertyDetail(renderingEnv.pageTemplateName, TEMPLATE_NAME_LOCATION);
    changePagePropertyDetail(renderingEnv.pageType, PAGE_TYPE_LOCATION);
  }

  /**
    toggle the new page modal
   */
  newPagemodalToggle() {
    this.setState(ps => ({ newPageModalisOpen: !ps.newPageModalisOpen }));
  }

  /**
    toggle the responsive content page modal
   */
  responsiveContentPageToggle() {
    this.setState(ps => ({ responsiveContentPageisOpen: !ps.responsiveContentPageisOpen }));
  }

  /**
   * render the new Page Page Rendering Environment Modal
   * @param {object} renderingEnv - rendering environment object
   * @returns {React.Component} new page modal
   */
  renderNewPageModal(renderingEnv) {
    return (
      <Modal
        isOpen={this.state.newPageModalisOpen}
        toggle={this.modalToggle}
        data-test-id="new-page-modal"
      >
        <ModalBody>
          <RenderingEnvironment
            onCancel={this.newPagemodalToggle}
            onEnter={renderingEnv => {
              this.setRenderingEnv(renderingEnv);
              this.newPagemodalToggle();
            }}
            environmentToRender={RENDERING_ENVIRONMENTS_FOR_PAGE}
            renderingEnv={renderingEnv}
          />
        </ModalBody>
      </Modal>
    );
  }

  /**
   * render the responsive Content Page Rendering Environment Modal
   * @param {object} renderingEnv - rendering environment object
   * @returns {React.Component} responsive Content page modal
   */
  renderResponsiveContentPageModal(renderingEnv) {
    return (
      <Modal
        isOpen={this.state.responsiveContentPageisOpen}
        toggle={this.responsiveContentPageToggle}
        data-test-id="responsive-content-modal"
      >
        <ModalBody>
          <RenderingEnvironment
            onCancel={this.responsiveContentPageToggle}
            onEnter={renderingEnv => {
              this.setRenderingEnv(renderingEnv);
              this.responsiveContentPageToggle();
            }}
            environmentToRender={RENDERING_ENVIRONMENTS_FOR_EDIT}
            renderingEnv={renderingEnv}
          />
        </ModalBody>
      </Modal>
    );
  }

  render() {
    const {
      className,
      pageType,
      pageTemplateName,
      renderingEnvCaption,
      isPage,
      isNewStatus
    } = this.props;

    // construct the renderingEnv props
    const renderingEnv = {
      pageTemplateName,
      pageType
    };

    const isResponsiveContent = isPage && pageType === PAGE_TYPES.RESPONSIVE_CONTENT;
    const isNewPage = isPage && isNewStatus;
    const pagTypeCaption = renderingEnvCaption.pageType;
    const pageTemplateNameCaption = renderingEnvCaption.pageTemplateName;

    return pageType ? (
      <div className={`${className} border rounded border-light p-1`}>
        <strong>{pagTypeCaption && pagTypeCaption}</strong>
        {pageTemplateNameCaption && ` (${pageTemplateNameCaption})`}
        {(isResponsiveContent || isNewPage) && (
          <IconButton
            className="d-inline-block ml-2"
            alt="edit rendering environment"
            data-test-id="edit-icon-button"
            icon={edit}
            noMargin
            rem={1.5}
            onClick={isNewPage ? this.newPagemodalToggle : this.responsiveContentPageToggle}
          />
        )}
        {isNewPage
          ? this.renderNewPageModal(renderingEnv)
          : this.renderResponsiveContentPageModal(renderingEnv)}
      </div>
    ) : (
      ''
    );
  }
}

export default EditRenderingEnvironment;
